module.exports = __webpack_public_path__ + "img/selected5-min.74ff7a78.png";